var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loading,style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px"),
  }),attrs:{"data-color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }